module.exports = __webpack_public_path__ + "static/img/img-02.31445758.png";